module.exports = __webpack_public_path__ + "img/slide18_vn.9476ed7d.jpg";